function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react';
export var NestedMenuContext = React.createContext({
  addMenuToNesting: function addMenuToNesting() {},
  removeMenuFromNesting: function removeMenuFromNesting() {},
  getParentMenu: function getParentMenu() {},
  getChildMenu: function getChildMenu() {},
  mountRef: {
    current: null
  }
});

function isSame(a, b) {
  if (!a || !b) {
    return false;
  }

  return a.isSameNode(b);
}

var NestedMenus =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NestedMenus, _React$Component);

  function NestedMenus() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NestedMenus);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NestedMenus)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menus: []
    });

    _defineProperty(_assertThisInitialized(_this), "mountRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "addMenuToNesting", function (ref) {
      // check offsetHeight to determine if component is visible in the dom (0 means hidden)
      // we need to do this so that when we renderAll, the hidden seo-only child-menus don't
      // register themselves which would break the nesting logic
      if (ref.current && ref.current.offsetHeight) {
        _this.setState(function (state) {
          return {
            menus: [].concat(_toConsumableArray(state.menus), [ref])
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeMenuFromNesting", function (ref) {
      _this.setState(function (state) {
        var nextMenus = state.menus.filter(function (r) {
          return r.current;
        }).filter(function (r) {
          return !isSame(r.current, ref.current);
        });
        return {
          menus: nextMenus
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "findMenuIndexByRef", function (ref) {
      return _this.state.menus.findIndex(function (r) {
        return isSame(r.current, ref.current);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getParentMenu", function (ref) {
      var index = _this.findMenuIndexByRef(ref) - 1;
      return _this.state.menus[index];
    });

    _defineProperty(_assertThisInitialized(_this), "getChildMenu", function (ref) {
      var index = _this.findMenuIndexByRef(ref) + 1;
      return _this.state.menus[index];
    });

    return _this;
  }

  _createClass(NestedMenus, [{
    key: "render",
    value: function render() {
      return React.createElement(NestedMenuContext.Provider, {
        value: {
          addMenuToNesting: this.addMenuToNesting,
          removeMenuFromNesting: this.removeMenuFromNesting,
          getParentMenu: this.getParentMenu,
          getChildMenu: this.getChildMenu,
          mountRef: this.mountRef
        }
      }, React.createElement(React.Fragment, null, this.props.children, React.createElement("span", {
        ref: this.mountRef
      })));
    }
  }]);

  return NestedMenus;
}(React.Component);

export { NestedMenus as default };